<template>
  <div class="main_right ammeter-add">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检点名称：</span>
        </div>
        <el-input v-model="formData.pointName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">巡检码：</span>
        </div>
        <el-input v-model="formData.pointCode" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检类目：</span>
        </div>
        <el-select v-model="formData.categoryCode" size="small" style="width: 280px">
          <el-option v-for="item in categoryList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检点位置：</span>
        </div>
        <el-input v-model="formData.location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡检是否需要拍照：</span>
        </div>
        <el-switch v-model="photoState" active-text="是" inactive-text="否"></el-switch>
      </div>

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">质保截止日期：</span>-->
<!--        </div>-->
<!--        <el-date-picker v-model="warrantyEndTime" type="date" placeholder="选择日期" size="small" style="width: 280px" value-format="yyyy-MM-dd"></el-date-picker>-->
<!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.desc" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/Inspection'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {treeApi} from '../../api/ElectronicTreeApi'
  // let a = document.getElementsByClassName()

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'inspection-device-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧巡检',
            name: 'inspection-device-type-manage'
          }, {
            value: '巡检点管理'
          }],
        },
        mainTitle: '添加巡检点',
        subheading: '',


        photoState: false,
        formData: {
          pointName: '',
          pointCode: '',
          categoryCode: '',
          categoryName: '',
          location: '',
          isPhoto: '0',
          desc: ''
        },

        categoryList: [],

        responsiblePersonCode: '',
        responsiblePersonList: [],

      }
    },
    created () {
      // this.getResponsiblePersonList()
      this.getInspectDeviceTypeList()
    },
    methods: {
      // 获取巡检类目
      getInspectDeviceTypeList () {
        this.$axios.get(api.getInspectDeviceTypeList, {})
          .then(res => {
            let list = res.data.data
            this.categoryList = list
          })
          .catch(errorHandler('获取巡检类目失败'))
      },

      // 获取责任人列表
      getResponsiblePersonList () {
        this.$axios.post(api.getResponsiblePersonList, {})
          .then(res => {
            let list = res.data.data
            list.map(v => {
              v._value = v.code
              v._label = `${v.name} / ${v.phone}`
            })
            this.responsiblePersonList = list
          })
          .catch(errorHandler('获取责任人列表失败'))
      },

      addNext () {
        if (!this.formData.pointName) {
          nError('请输入巡检点名称')
          return false
        }
        if (!this.formData.categoryCode) {
          nError('请选择巡检类目')
          return false
        }
        if (!this.formData.location) {
          nError('请输入巡检点位置')
          return false
        }
        this.categoryList.map(v => {
          if (v.code === this.formData.categoryCode) {
            this.formData.categoryName = v.name
          }
        })
        if (this.photoState) {
          this.formData.isPhoto = '1'
        } else {
          this.formData.isPhoto = '0'
        }
        this.$axios.post(api.addInspectDevice, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.photoState = false
              this.formData = {
                pointName: '',
                pointCode: '',
                categoryCode: '',
                categoryName: '',
                location: '',
                isPhoto: '0',
                desc: ''
              }
            }
          })
          .catch(errorHandler('添加失败'))
      },
      add () {
        if (!this.formData.pointName) {
          nError('请输入巡检点名称')
          return false
        }
        if (!this.formData.categoryCode) {
          nError('请选择巡检类目')
          return false
        }
        if (!this.formData.location) {
          nError('请输入巡检点位置')
          return false
        }
        this.categoryList.map(v => {
          if (v.code === this.formData.categoryCode) {
            this.formData.categoryName = v.name
          }
        })
        if (this.photoState) {
          this.formData.isPhoto = '1'
        } else {
          this.formData.isPhoto = '0'
        }
        this.$axios.post(api.addInspectDevice, this.formData)
          .then(res => {
            nSuccess('添加成功')
            this.strategyCenter()
          })
          .catch(errorHandler('添加失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'inspection-device-manage'
        })
      }
    },
    watch: {}
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 15px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 160px;
    text-align: right;
  }
  .form-btn-box {
    width: 605px;
    padding: 0 162px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .ammeter-add {
    .electricity {
      .el-input__inner {
        padding: 0 0 0 15px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionDevice/InspectionDeviceAdd.vue